const base64js = require('base64-js');
import Validator from 'validatorjs';

/* @ngInject */
export default class AuditorsDashboardCtrl {
    constructor(
        $scope,
        $rootScope,
        $timeout,
        AuditorsDashboardService,
        NotificationService,
        LocalStorageService,
        BuildingsService
    ) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.AuditorsDashboardService = AuditorsDashboardService;
        this.NotificationService = NotificationService;
        this.LocalStorageService = LocalStorageService;
        this.BuildingsService = BuildingsService;

        this.init();
        this.loadDashboard();
        this._registerEventHandler();
        this.activate();
    }

    init() {
        this.isBusy = true;
        this.howToGuideLink;
        this.auditorToken = "";
        this.auditorSchemes = [];
        this.auditorName = "";
        this.openAuditorSchemeInfo = {};
        this.auditsToken = "";
        this.showNoTokenMsg = false;

        this.selectedBuildingRef = this.LocalStorageService.retrieve("selectedBuildingRef");
        this.financialPeriodHeaderId = this.LocalStorageService.retrieve("auditsFinancialPeriodHeaderId");

        var url = window.location.search;
        if (url.split("=")[0].toLowerCase() == "?auditortoken") {
            this.auditorToken = url.split("=")[1];
        }

        if (!this.auditorToken) {
            this.auditorToken = this.LocalStorageService.retrieve("auditorToken");
        }

        if (!this.auditorToken) {
            this.LocalStorageService.clear("Audits");
            this.LocalStorageService.clear("Auditor");
            this.showNoTokenMsg = true;
        }
    }

    _registerEventHandler() {}

    activate() {
        this.howToGuideLink = `${PretorCDNAddress}${PretorCDNAddress.endsWith('/')
            ? ''
            : '/'}docs/Audits How-To-Guide.pdf`;
    }

    _switchIsBusy(flag) {
        this.$timeout(() => {
            this.isBusy = flag;
        });
    }

    loadDashboard() {
        if (!this.showNoTokenMsg) {
            this._switchIsBusy(true);
            if (this.financialPeriodHeaderId && this.selectedBuildingRef) {
                this.showSchemeAuditsInfo(this.financialPeriodHeaderId, this.selectedBuildingRef)
            }
            this.GetAuditorSchemeInformation();
        } else {
            this._switchIsBusy(false)
        }
    }

	async GetAuditorSchemeInformation() {
        var auditsData = await this.AuditorsDashboardService.GetAuditorSchemes(this.auditorToken);

        auditsData.Data.forEach(function (searchResult) {
            var monthNames = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];

            var dateChange = searchResult.EndOfFinancialYear.substring(0, 10);
            var inputDate = new Date(dateChange);

            // Get the day, month, and year
            var day = inputDate.getDate();
            var monthIndex = inputDate.getMonth();
            var year = inputDate.getFullYear();

            // Format the Date object to a more readable format
            var parsedDate = day + ' ' + monthNames[monthIndex] + ' ' + year;
            searchResult.EndOfFinancialYear = parsedDate;
        });

        var auditorHeaderId = auditsData.Data[0].AuditorHeaderId;
        var auditorInfo = await this.AuditorsDashboardService.getAuditorByAuditorHeaderId(auditorHeaderId);
        this.auditorName = auditorInfo.Auditor;
        this.auditorSchemes = auditsData.Data;

        $('#auditsSchemesTbl').prop('hidden', false);
        this._switchIsBusy(false);
    }

    async showSchemeAuditsInfo(FinancialPeriodHeaderId, DB_Ref) {
        const auditTokenDetailsToOpen = await this.AuditorsDashboardService.GetAuditDetailsToView(FinancialPeriodHeaderId, DB_Ref);

        this.selectedBuildingRef = DB_Ref
        this.financialPeriodHeaderId = FinancialPeriodHeaderId;

        this.LocalStorageService.save("auditsFinancialPeriodHeaderId", this.financialPeriodHeaderId);

        this.BuildingsService.setSelectedBuildingRef(this.selectedBuildingRef);
        this.$rootScope.$broadcast('selected-building-changed', this.selectedBuildingRef);
        this.$scope.$broadcast('selected-building-changed', this.selectedBuildingRef);

        this.auditsToken = auditTokenDetailsToOpen.Data[0].Token;
        this.LocalStorageService.save("auditsToken", this.auditsToken);

        await this.AuditorsDashboardService.openAuditsDetails(this.auditsToken);
    }

	async GetAuditorDashboardToExcel() {
		var excelDocument = await this.AuditorsDashboardService.GetAuditorDashboardToExcel(this.AuditorsDashboardService.auditorHeaderDetails.Id);
		const worksheet = XLSX.utils.json_to_sheet(excelDocument);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Dashboard Summary");

		/* fix headers */
		XLSX.utils.sheet_add_aoa(worksheet, [["QueryNumber", "DateLogged", "WhoLogged", "BuildingName", "Pretor ID", "Message", "Assignee", "Query Subject", "Status"]], { origin: "A1" });

		/* calculate column width */
		var wscols = [
			{ width: 15 },  // first column
			{ width: 20 }, // second column
			{ width: 16 },
			{ width: 43 },
			{ width: 38 },
			{ width: 50 },
			{ width: 17 },
			{ width: 30 },
			{ width: 15 }
		];
		worksheet["!cols"] = wscols;
		worksheet['!cols'][4] = { hidden: true };
		XLSX.writeFile(workbook, "DashboardSummary.xlsx");
    }
}
